import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Recomendation from "./components/Recomendation";
import About from "./components/About";
import Skills from "./components/Skills";
import Work from "./components/Work";
import Contact from "./components/Contact";

function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <Recomendation />
      <About />
      <Skills />
      <Work />
      <Contact />
    </div>
  );
}

export default App;
